<!--
  - Copyright (c) 2019 Eva Novotná, Juraj Šimon
  -->

<template>
  <div class="slider-wrapper">
    <swiper ref="mySwiper" class="top-swiper" :options="swiperOptions">
      <slide
        background-image-class="skiing"
        bottom-label="lyžování"
        top-label="Trenér"
        :swap-styles="true"
      ></slide>
      <slide
        background-image-class="swimming"
        bottom-label="plavání"
        top-label="Trenér"
        :swap-styles="true"
      ></slide>
      <slide
        background-image-class="running"
        bottom-label="běhání"
        top-label="Trenér"
        :swap-styles="true"
      ></slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swipe-prev" slot="button-prev">
        <left-arrow class="arrow" @click="swipePrev" />
      </div>
      <div class="swipe-next" slot="button-next">
        <right-arrow class="arrow" @click="swipeNext" />
      </div>
    </swiper>
    <slot name="bottom-bar"></slot>
  </div>
</template>

<script>
import LeftArrow from "./../assets/keyboard_arrow_left-24px.svg";
import RightArrow from "./../assets/keyboard_arrow_right-24px.svg";
import Slide from "./top-slider/slide";

export default {
  props: {},
  components: {
    LeftArrow,
    RightArrow,
    Slide
  },
  methods: {
    swipeNext() {
      this.swiper.slideNext(500);
    },
    swipePrev() {
      this.swiper.slidePrev(500);
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    swiperOptions() {
      return {
        slidesPerView: 1,
        autoplay: {
          delay: 3000
        },
        // autoHeight: true,
        spaceBetween: 0,
        allowTouchMove: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      };
    }
  }
};
</script>

<style lang="scss">
@import "sports";
@import "top-slider-unscoped";
</style>
